import {createSlice, PayloadAction, SliceCaseReducers} from '@reduxjs/toolkit';
import {ClientInfoResponsePayload} from '../../../shared/models/api/skipassResponsePayload';
import {AppActions} from '../../actions';

export interface SkipassState {
  clientInfo: ClientInfoResponsePayload | null;
  isLoading: boolean;
}

const initialState: SkipassState = {
  clientInfo: null,
  isLoading: false,
};

export const skipassSlice = createSlice<SkipassState, SliceCaseReducers<SkipassState>>({
  name: '@@eskso/skipass',
  initialState,
  reducers: {
    setSkipassClientInfo: (state, action: PayloadAction<ClientInfoResponsePayload>) => {
      state.clientInfo = action.payload;
    },
    setClientInfoLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
  extraReducers: {
    [AppActions.Reset]: () => {
      return initialState;
    },
  },
});

export const skipass = skipassSlice.reducer;
